// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"SendgridSettingsList_contentComponent__2i2Cc","tableContainer":"SendgridSettingsList_tableContainer__3LRQ1","root":"SendgridSettingsList_root__1PS3h"};